import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";
import "../Admin_panal/Admin_panal.css";
import { MdKeyboardArrowRight } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { showToast } from "../../utils/customToast";
import { performLogout } from "../../utils/auth";
import { SECURITY_KEY } from "../../globals";
import { useCompany } from "../../context/CompanyContext";

/* ==========================================================================
   SIDEBAR COMPONENT
   ========================================================================== */
export function Sidebar({ admin, setadmin }) {
  // Navigation group accordion states
  const [masterOpen, setMasterOpen] = useState(true);
  const [vehiclesOpen, setVehiclesOpen] = useState(false);
  const [faresOpen, setFaresOpen] = useState(false);
  const [ledgerOpen, setLedgerOpen] = useState(false);
  const [operationsOpen, setOperationsOpen] = useState(false);
  const [bookingsOpen, setBookingsOpen] = useState(false);
  const [invoiceOpen, setInvoiceOpen] = useState(false);
  const [voucherOpen, setVoucherOpen] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);
  const [utilityOpen, setUtilityOpen] = useState(false);

  const [userType, setUserType] = useState(() => localStorage.getItem("userType") || "");
  const location = useLocation();
  const navigate = useNavigate();
  const sidebarRef = useRef(null);

  // Auto-expand accordion based on active route
  useEffect(() => {
    const p = location.pathname.toLowerCase();
    if (
      p.includes("compny") ||
      p.includes("user") ||
      p.includes("tax") ||
      p.includes("service") ||
      p.includes("vehicle") ||
      p.includes("fares") ||
      p.includes("fare") ||
      p.includes("group") ||
      p.includes("ledger") ||
      p.includes("selectdata")
    ) {
      setMasterOpen(true);
      if (p.includes("vehicle")) {
        setVehiclesOpen(true);
      }
      if (p.includes("fare") || p.includes("fares")) {
        setFaresOpen(true);
      }
      if (p.includes("ledger") || p.includes("group")) {
        setLedgerOpen(true);
      }
    } else if (p.includes("booking") || p.includes("dutyslip") || p.includes("invoice") || p.includes("bills")) {
      setOperationsOpen(true);
      if (p.includes("booking") || p.includes("dutyslip")) {
        setBookingsOpen(true);
      }
      if (p.includes("invoice") || p.includes("bills")) {
        setInvoiceOpen(true);
      }
    } else if (p.includes("transaction") || p.includes("voucher")) {
      setVoucherOpen(true);
    } else if (p.includes("configuration") || p.includes("settings") || p.includes("utility")) {
      setUtilityOpen(true);
    } else if (
      p.includes("gst-tax-register") ||
      p.includes("tax-register") ||
      p.includes("day-book") ||
      p.includes("purchase-register") ||
      p.includes("trial-balance") ||
      p.includes("monthly-ledger-summary") ||
      p.includes("ledger-transactions") ||
      p.includes("group-summary") ||
      p.includes("group-ledger-summary") ||
      p.includes("profit-loss") ||
      p.includes("balance-sheet") ||
      p.includes("cash-book") ||
      p.includes("bank-book") ||
      p.includes("journal-register")
    ) {
      setReportsOpen(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    const updateUserType = () => {
      const stored = localStorage.getItem("userType") || "";
      setUserType(stored);
    };
    updateUserType();
    window.addEventListener("companyChanged", updateUserType);
    window.addEventListener("storage", updateUserType);
    return () => {
      window.removeEventListener("companyChanged", updateUserType);
      window.removeEventListener("storage", updateUserType);
    };
  }, [location.pathname]);

  const handleMobileNavClick = () => {
    if (window.innerWidth <= 768) {
      setadmin(true);
    }
  };

  const isRouteActive = (paths) => {
    const current = location.pathname.toLowerCase();
    if (Array.isArray(paths)) {
      return paths.some((p) => {
        const pl = p.toLowerCase();
        if (pl === "/") return current === "/";
        return current === pl || current.startsWith(pl.endsWith("/") ? pl : pl + "/");
      });
    }
    const pl = paths.toLowerCase();
    if (pl === "/") return current === "/";
    return current === pl || current.startsWith(pl.endsWith("/") ? pl : pl + "/");
  };

  const isDashboardActive = location.pathname.toLowerCase() === "/home" || location.pathname === "/";

  const isMasterActive = isRouteActive([
    "/selectcompny",
    "/compney",
    "/compupdate",
    "/addcompany",
    "/updatecompany",
    "/users",
    "/newuser",
    "/newusers",
    "/updateuser",
    "/usermaster",
    "/adduser",
    "/taxes",
    "/taxmaster",
    "/addtax",
    "/updatetax",
    "/showservice",
    "/servisemaster",
    "/servicemaster",
    "/updateservice",
    "/updateservicemast",
    "/addservice",
    "/showvehicletype",
    "/vehicletype",
    "/upvehicletype",
    "/addvehicletype",
    "/updatevehicletype",
    "/fares",
    "/showfares",
    "/payable",
    "/receivable",
    "/addfare",
    "/updatefare",
    "/updatefares",
    "/groupmaster",
    "/addgroup",
    "/updategroup",
    "/ledger",
    "/addledger",
    "/updateledger",
    "/showledger",
    "/vehicles",
    "/addvehicles",
    "/updatevehicles",
    "/updatevehile",
  ]);

  const isOperationsActive = isRouteActive([
    "/booking",
    "/dutyslip",
    "/duty-slip",
    "/billsinvoice",
    "/modify-invoice",
    "/viewinvoice",
    "/invoice-details",
    "/invoice",
    "/invoicedetails",
    "/addinvoice",
  ]);

  const isTransactionActive = isRouteActive([
    "/transactions/voucher-entry",
    "/voucher-entry",
    "/transactions/modify-voucher",
    "/modify-voucher",
    "/vouchers",
    "/transactions",
  ]);

  const isReportsActive = isRouteActive([
    "/gst-tax-register",
    "/trial-balance",
    "/reports/trial-balance",
    "/monthly-ledger-summary",
    "/reports/monthly-ledger-summary",
    "/ledger-transactions",
    "/reports/ledger-transactions",
    "/group-ledger-summary",
    "/reports/group-ledger-summary",
    "/group-summary",
    "/reports/group-summary",
    "/journal-register",
    "/reports/journal-register",
    "/day-book",
    "/reports/day-book",
    "/cash-book",
    "/reports/cash-book",
    "/bank-book",
    "/reports/bank-book",
    "/purchase-register",
    "/reports/purchase-register",
    "/sales-register",
    "/reports/sales-register",
    "/profit-loss",
    "/reports/profit-loss",
    "/pnl-statement",
    "/reports/pnl-statement",
    "/balance-sheet",
    "/reports/balance-sheet",
    "/ledger-report",
  ]);

  const isUtilityActive = isRouteActive([
    "/configuration",
    "/settings",
    "/master/configuration",
    "/import-ledger",
    "/utility/import-ledger",
  ]);

  const handleLogout = () => {
    performLogout("Logged out successfully");
  };

  return (
    <aside ref={sidebarRef} className={`sidebar ${admin ? "collapsed" : ""}`}>
      {/* Full-height border hover trigger zone */}
      <div
        className="sidebar_border_hover_zone"
        onClick={() => setadmin(!admin)}
        title={admin ? "Click to expand sidebar" : "Click to collapse sidebar"}
      >
        {/* Floating Middle Toggle Arrow */}
        <button
          type="button"
          className={`sidebar_edge_toggle_btn ${admin ? "collapsed" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            setadmin(!admin);
          }}
          title={admin ? "Expand Sidebar" : "Collapse Sidebar"}
          aria-label="Toggle Sidebar"
        >
          <i className="fa-solid fa-chevron-left"></i>
        </button>
      </div>

      {/* Top Logo Brand */}
      <div className="sidebar_brand_container">
        <Link
          to={userType === "9" ? "/selectdata" : "/home"}
          onClick={handleMobileNavClick}
          className="sidebar_brand_link"
        >
          <div className="sidebar_brand_mark">
            <i className="fa-solid fa-route"></i>
          </div>
          {!admin && (
            <div className="sidebar_brand_text">
              <span className="sidebar_brand_accent">e</span>
              <span className="sidebar_brand_main">Tour</span>
            </div>
          )}
        </Link>
      </div>

      {/* Sidebar Navigation Menu */}
      <div className="dashbord_text-div custom_scrollbar">
        {/* SECTION: MAIN */}
        {userType !== "9" && (
          <>
            {!admin && <div className="sidebar_section_title">MAIN</div>}

            <Link
              to="/home"
              onClick={() => {
                handleMobileNavClick();
                if (admin) setadmin(false);
              }}
              className={`sidebar_nav_item ${isDashboardActive ? "active" : ""}`}
              title="Dashboard"
            >
              <i className="fa-solid fa-house"></i>
              {!admin && <span>Dashboard</span>}
            </Link>
          </>
        )}

        {/* SECTION: MASTER DATA */}
        {!admin && <div className="sidebar_section_title">MASTER DATA</div>}

        {userType === "9" ? (
          <Link
            to="/selectdata"
            onClick={() => {
              handleMobileNavClick();
              if (admin) setadmin(false);
            }}
            className={`sidebar_nav_item ${
              isRouteActive(["/selectdata", "/masterdata", "/updatedata", "/resetpass"])
                ? "active"
                : ""
            }`}
            title="Master Data"
          >
            <i className="fa-solid fa-database"></i>
            {!admin && <span>Master Data</span>}
          </Link>
        ) : (
          <div
            className={`sidebar_nav_group ${isMasterActive ? "group_active" : ""}`}
          >
            <div
              className={`sidebar_nav_item group_header ${isMasterActive ? "active" : ""}`}
              onClick={() => {
                if (admin) {
                  setadmin(false);
                  setMasterOpen(true);
                  navigate("/selectcompny");
                } else {
                  setMasterOpen(!masterOpen);
                }
              }}
              title="Master"
            >
              <i className="fa-solid fa-pen-nib"></i>
              {!admin && (
                <>
                  <span>Master</span>
                  <span className={`group_arrow ${masterOpen ? "open" : ""}`}>
                    <MdKeyboardArrowRight />
                  </span>
                </>
              )}
            </div>

            {masterOpen && !admin && (
              <div className="sidebar_submenu">
                <Link
                  to="/selectcompny"
                  onClick={handleMobileNavClick}
                  className={`sidebar_sub_item ${isRouteActive(["/selectcompny", "/Compney", "/Compupdate"]) ? "active" : ""}`}
                >
                  <i className="fa-solid fa-building"></i>
                  <span>Company</span>
                </Link>

                <Link
                  to="/users"
                  onClick={handleMobileNavClick}
                  className={`sidebar_sub_item ${isRouteActive(["/users", "/NewUser", "/Updateuser"]) ? "active" : ""}`}
                >
                  <i className="fa-solid fa-user-gear"></i>
                  <span>Users</span>
                </Link>

                <Link
                  to="/taxes"
                  onClick={handleMobileNavClick}
                  className={`sidebar_sub_item ${isRouteActive("/taxes") ? "active" : ""}`}
                >
                  <i className="fa-solid fa-percent"></i>
                  <span>Taxes</span>
                </Link>

                <Link
                  to="/showservice"
                  onClick={handleMobileNavClick}
                  className={`sidebar_sub_item ${isRouteActive(["/showservice", "/Servisemaster", "/servicemaster", "/servisemaster", "/Updateservice", "/updateservice"]) ? "active" : ""}`}
                >
                  <i className="fa-solid fa-bell-concierge"></i>
                  <span>Service Master</span>
                </Link>

                {/* Nested Vehicles Group */}
                <div className="sidebar_nested_group">
                  <div
                    className={`sidebar_sub_item nested_header ${isRouteActive(["/Vehicles", "/AddVehicles", "/UpdateVehicles", "/showvehicletype", "/vehicletype", "/UpVehicleType"]) ? "active_parent" : ""}`}
                    onClick={() => setVehiclesOpen(!vehiclesOpen)}
                  >
                    <span className="nested_header_content">
                      <i className="fa-solid fa-car-side"></i>
                      <span>Vehicles</span>
                    </span>
                    <span className={`nested_arrow ${vehiclesOpen ? "open" : ""}`}>
                      <MdKeyboardArrowRight />
                    </span>
                  </div>

                  {vehiclesOpen && (
                    <div className="sidebar_nested_submenu">
                      <Link
                        to="/Vehicles"
                        onClick={handleMobileNavClick}
                        className={`sidebar_sub_item nested_child ${isRouteActive(["/Vehicles", "/AddVehicles", "/UpdateVehicles"]) ? "active" : ""}`}
                      >
                        <i className="fa-solid fa-car"></i>
                        <span>Vehicles List</span>
                      </Link>

                      <Link
                        to="/showvehicletype"
                        onClick={handleMobileNavClick}
                        className={`sidebar_sub_item nested_child ${isRouteActive(["/showvehicletype", "/vehicletype", "/UpVehicleType"]) ? "active" : ""}`}
                      >
                        <i className="fa-solid fa-shapes"></i>
                        <span>Vehicle Type</span>
                      </Link>
                    </div>
                  )}
                </div>

                {/* Nested Fares Group */}
                <div className="sidebar_nested_group">
                  <div
                    className={`sidebar_sub_item nested_header ${isRouteActive(["/showfares", "/Addfare", "/Updatefare"]) ? "active_parent" : ""}`}
                    onClick={() => setFaresOpen(!faresOpen)}
                  >
                    <span className="nested_header_content">
                      <i className="fa-solid fa-tags"></i>
                      <span>Packages & Fares</span>
                    </span>
                    <span className={`nested_arrow ${faresOpen ? "open" : ""}`}>
                      <MdKeyboardArrowRight />
                    </span>
                  </div>

                  {faresOpen && (
                    <div className="sidebar_nested_submenu">
                      <Link
                        to="/showfares"
                        onClick={handleMobileNavClick}
                        className={`sidebar_sub_item nested_child ${location.pathname.includes("/showfares") && !location.search.includes("receivable") ? "active" : ""}`}
                      >
                        <i className="fa-solid fa-wallet"></i>
                        <span>Payable Fares</span>
                      </Link>

                      <Link
                        to="/showfares?type=receivable"
                        onClick={handleMobileNavClick}
                        className={`sidebar_sub_item nested_child ${location.search.includes("receivable") ? "active" : ""}`}
                      >
                        <i className="fa-solid fa-hand-holding-dollar"></i>
                        <span>Receivable Fares</span>
                      </Link>
                    </div>
                  )}
                </div>

                {/* Nested Ledger Group */}
                <div className="sidebar_nested_group">
                  <div
                    className={`sidebar_sub_item nested_header ${isRouteActive(["/Ledger", "/AddLedger", "/UpdateLedger", "/GroupMaster", "/AddGroup", "/UpdateGroup"]) ? "active_parent" : ""}`}
                    onClick={() => setLedgerOpen(!ledgerOpen)}
                  >
                    <span className="nested_header_content">
                      <i className="fa-solid fa-book-bookmark"></i>
                      <span>Ledger</span>
                    </span>
                    <span className={`nested_arrow ${ledgerOpen ? "open" : ""}`}>
                      <MdKeyboardArrowRight />
                    </span>
                  </div>

                  {ledgerOpen && (
                    <div className="sidebar_nested_submenu">
                      <Link
                        to="/Ledger"
                        onClick={handleMobileNavClick}
                        className={`sidebar_sub_item nested_child ${isRouteActive(["/Ledger", "/AddLedger", "/UpdateLedger"]) ? "active" : ""}`}
                      >
                        <i className="fa-solid fa-address-book"></i>
                        <span>Ledger Master</span>
                      </Link>

                      <Link
                        to="/GroupMaster"
                        onClick={handleMobileNavClick}
                        className={`sidebar_sub_item nested_child ${isRouteActive(["/GroupMaster", "/AddGroup", "/UpdateGroup"]) ? "active" : ""}`}
                      >
                        <i className="fa-solid fa-layer-group"></i>
                        <span>Group Master</span>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* SECTION: OPERATIONS */}
        {userType !== "9" && (
          <>
            {!admin && <div className="sidebar_section_title">OPERATIONS</div>}

        <div
          className={`sidebar_nav_group ${isOperationsActive ? "group_active" : ""}`}
        >
          <div
            className={`sidebar_nav_item group_header ${isOperationsActive ? "active" : ""}`}
            onClick={() => {
              if (admin) {
                setadmin(false);
                setOperationsOpen(true);
                navigate("/Booking");
              } else {
                setOperationsOpen(!operationsOpen);
              }
            }}
            title="Operations"
          >
            <i className="fa-solid fa-briefcase"></i>
            {!admin && (
              <>
                <span>Operations</span>
                <span className={`group_arrow ${operationsOpen ? "open" : ""}`}>
                  <MdKeyboardArrowRight />
                </span>
              </>
            )}
          </div>

          {operationsOpen && !admin && (
            <div className="sidebar_submenu">
              {/* Nested Booking Group */}
              <div className="sidebar_nested_group">
                <div
                  className={`sidebar_sub_item nested_header ${isRouteActive(["/Booking", "/Dutyslip"]) ? "active_parent" : ""}`}
                  onClick={() => setBookingsOpen(!bookingsOpen)}
                >
                  <span className="nested_header_content">
                    <i className="fa-solid fa-calendar-check"></i>
                    <span>Booking</span>
                  </span>
                  <span className={`nested_arrow ${bookingsOpen ? "open" : ""}`}>
                    <MdKeyboardArrowRight />
                  </span>
                </div>

                {bookingsOpen && (
                  <div className="sidebar_nested_submenu">
                    <Link
                      to="/Booking"
                      onClick={handleMobileNavClick}
                      className={`sidebar_sub_item nested_child ${isRouteActive("/Booking") ? "active" : ""}`}
                    >
                      <i className="fa-solid fa-calendar-days"></i>
                      <span>Booking</span>
                    </Link>
                    <Link
                      to="/Dutyslip"
                      onClick={handleMobileNavClick}
                      className={`sidebar_sub_item nested_child ${isRouteActive("/Dutyslip") ? "active" : ""}`}
                    >
                      <i className="fa-solid fa-file-invoice"></i>
                      <span>Duty Slip</span>
                    </Link>
                  </div>
                )}
              </div>

              {/* Nested Invoice Group */}
              <div className="sidebar_nested_group">
                <div
                  className={`sidebar_sub_item nested_header ${isRouteActive(["/BillsInvoice", "/ViewInvoice", "/modify-invoice"]) ? "active_parent" : ""}`}
                  onClick={() => setInvoiceOpen(!invoiceOpen)}
                >
                  <span className="nested_header_content">
                    <i className="fa-solid fa-file-invoice-dollar"></i>
                    <span>Invoice</span>
                  </span>
                  <span className={`nested_arrow ${invoiceOpen ? "open" : ""}`}>
                    <MdKeyboardArrowRight />
                  </span>
                </div>

                {invoiceOpen && (
                  <div className="sidebar_nested_submenu">
                    <Link
                      to="/BillsInvoice"
                      onClick={handleMobileNavClick}
                      className={`sidebar_sub_item nested_child ${isRouteActive("/BillsInvoice") ? "active" : ""}`}
                    >
                      <i className="fa-solid fa-circle-plus"></i>
                      <span>New Invoice</span>
                    </Link>
                    <Link
                      to="/ViewInvoice"
                      onClick={handleMobileNavClick}
                      className={`sidebar_sub_item nested_child ${isRouteActive("/ViewInvoice") ? "active" : ""}`}
                    >
                      <i className="fa-solid fa-list-check"></i>
                      <span>Invoice List</span>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* SECTION: TRANSACTION */}
        {!admin && <div className="sidebar_section_title">TRANSACTION</div>}

        <div
          className={`sidebar_nav_group ${isTransactionActive ? "group_active" : ""}`}
        >
          <div
            className={`sidebar_nav_item group_header ${isTransactionActive ? "active" : ""}`}
            onClick={() => {
              if (admin) {
                setadmin(false);
                setVoucherOpen(true);
                navigate("/transactions/voucher-entry");
              } else {
                setVoucherOpen(!voucherOpen);
              }
            }}
            title="Transaction"
          >
            <i className="fa-solid fa-money-bill-transfer"></i>
            {!admin && (
              <>
                <span>Transaction</span>
                <span className={`group_arrow ${voucherOpen ? "open" : ""}`}>
                  <MdKeyboardArrowRight />
                </span>
              </>
            )}
          </div>

          {voucherOpen && !admin && (
            <div className="sidebar_submenu">
              <Link
                to="/transactions/voucher-entry"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${
                  isRouteActive(["/transactions/voucher-entry", "/voucher-entry"]) &&
                  !location.pathname.includes("modify") &&
                  !location.search.includes("mode=modify")
                    ? "active"
                    : ""
                }`}
              >
                <i className="fa-solid fa-pen-to-square"></i>
                <span>Voucher Entry</span>
              </Link>
              <Link
                to="/transactions/modify-voucher"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${
                  isRouteActive(["/transactions/modify-voucher", "/modify-voucher"]) ||
                  (isRouteActive(["/transactions/voucher-entry", "/voucher-entry"]) &&
                    (location.pathname.includes("modify") || location.search.includes("mode=modify")))
                    ? "active"
                    : ""
                }`}
              >
                <i className="fa-solid fa-clock-rotate-left"></i>
                <span>Modify Voucher</span>
              </Link>
            </div>
          )}
        </div>

        {/* SECTION: REPORTS */}
        <div
          className={`sidebar_nav_group ${isReportsActive ? "group_active" : ""}`}
        >
          <div
            className={`sidebar_nav_item group_header ${isReportsActive ? "active" : ""}`}
            onClick={() => {
              if (admin) {
                setadmin(false);
                setReportsOpen(true);
              } else {
                setReportsOpen(!reportsOpen);
              }
            }}
            title="Reports"
          >
            <i className="fa-regular fa-file-lines"></i>
            {!admin && (
              <>
                <span>Reports</span>
                <span className={`group_arrow ${reportsOpen ? "open" : ""}`}>
                  <MdKeyboardArrowRight />
                </span>
              </>
            )}
          </div>

          {reportsOpen && !admin && (
            <div className="sidebar_submenu">
              <Link
                to="/monthly-ledger-summary"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive(["/monthly-ledger-summary", "/reports/monthly-ledger-summary", "/ledger-transactions", "/reports/ledger-transactions"]) ? "active" : ""}`}
              >
                <i className="fa-solid fa-book"></i>
                <span>Ledger</span>
              </Link>
              <Link
                to="/gst-tax-register"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive("/gst-tax-register") ? "active" : ""}`}
              >
                <i className="fa-solid fa-percent"></i>
                <span>GST / Tax Register</span>
              </Link>
              <Link
                to="/day-book"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive(["/day-book", "/reports/day-book"]) ? "active" : ""}`}
              >
                <i className="fa-solid fa-calendar-day"></i>
                <span>Day Book</span>
              </Link>
              <Link
                to="/journal-register"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive(["/journal-register", "/reports/journal-register"]) ? "active" : ""}`}
              >
                <i className="fa-solid fa-book-journal-whills"></i>
                <span>Journal Register</span>
              </Link>
              <Link
                to="/purchase-register"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive(["/purchase-register", "/reports/purchase-register"]) ? "active" : ""}`}
              >
                <i className="fa-solid fa-cart-shopping"></i>
                <span>Purchase Register</span>
              </Link>
              <Link
                to="/cash-book"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive(["/cash-book", "/reports/cash-book"]) ? "active" : ""}`}
              >
                <i className="fa-solid fa-money-bill-wave"></i>
                <span>Cash Book</span>
              </Link>
              <Link
                to="/bank-book"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive(["/bank-book", "/reports/bank-book"]) ? "active" : ""}`}
              >
                <i className="fa-solid fa-building-columns"></i>
                <span>Bank Book</span>
              </Link>
              <Link
                to="/group-ledger-summary"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive(["/group-ledger-summary", "/reports/group-ledger-summary"]) ? "active" : ""}`}
              >
                <i className="fa-solid fa-folder-tree"></i>
                <span>Group Ledger Summary</span>
              </Link>
              <Link
                to="/group-summary"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive(["/group-summary", "/reports/group-summary"]) ? "active" : ""}`}
              >
                <i className="fa-solid fa-cubes"></i>
                <span>Group Summary</span>
              </Link>
              <Link
                to="/trial-balance"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive("/trial-balance") ? "active" : ""}`}
              >
                <i className="fa-solid fa-scale-balanced"></i>
                <span>Trial Balance</span>
              </Link>
              <Link
                to="/profit-loss"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive(["/profit-loss", "/reports/profit-loss", "/pnl-statement", "/reports/pnl-statement"]) ? "active" : ""}`}
              >
                <i className="fa-solid fa-chart-line"></i>
                <span>Profit & Loss</span>
              </Link>
              <Link
                to="/balance-sheet"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive(["/balance-sheet", "/reports/balance-sheet"]) ? "active" : ""}`}
              >
                <i className="fa-solid fa-file-contract"></i>
                <span>Balance Sheet</span>
              </Link>
            </div>
          )}
        </div>

        {/* SECTION: UTILITY */}
        {!admin && <div className="sidebar_section_title">UTILITY</div>}

        <div
          className={`sidebar_nav_group ${isUtilityActive ? "group_active" : ""}`}
        >
          <div
            className={`sidebar_nav_item group_header ${isUtilityActive ? "active" : ""}`}
            onClick={() => {
              if (admin) {
                setadmin(false);
                setUtilityOpen(true);
                navigate("/configuration");
              } else {
                setUtilityOpen(!utilityOpen);
              }
            }}
            title="Utility"
          >
            <i className="fa-solid fa-wrench"></i>
            {!admin && (
              <>
                <span>Utility</span>
                <span className={`group_arrow ${utilityOpen ? "open" : ""}`}>
                  <MdKeyboardArrowRight />
                </span>
              </>
            )}
          </div>

          {utilityOpen && !admin && (
            <div className="sidebar_submenu">
              <Link
                to="/configuration"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive(["/configuration", "/settings"]) ? "active" : ""}`}
              >
                <i className="fa-solid fa-sliders"></i>
                <span>Configuration</span>
              </Link>
              <Link
                to="/import-ledger"
                onClick={handleMobileNavClick}
                className={`sidebar_sub_item ${isRouteActive(["/import-ledger"]) ? "active" : ""}`}
              >
                <i className="fa-solid fa-file-import"></i>
                <span>Import Ledger</span>
              </Link>
              <span className="sidebar_sub_item">
                <i className="fa-solid fa-cloud-arrow-up"></i>
                <span>Backup</span>
              </span>
              <span className="sidebar_sub_item">
                <i className="fa-solid fa-rotate-left"></i>
                <span>Restore</span>
              </span>
            </div>
          )}
        </div>
          </>
        )}

        {/* LOGOUT BUTTON */}
        <div
          className="sidebar_nav_item sidebar_logout_btn"
          onClick={handleLogout}
          title="Log Out"
        >
          <i className="fa-solid fa-arrow-right-from-bracket"></i>
          {!admin && <span>Log Out</span>}
        </div>
      </div>
    </aside>
  );
}

/* ==========================================================================
   APPBAR / HEADER COMPONENT
   ========================================================================== */
export function Header({ admin, setadmin }) {
  const location = useLocation();
  const navigate = useNavigate();
  const isDashboard = location.pathname.toLowerCase() === "/home" || location.pathname === "/";

  const [profileOpen, setProfileOpen] = useState(false);
  const [showCompanyList, setShowCompanyList] = useState(false);
  const [companySearch, setCompanySearch] = useState("");

  const [username, setUsername] = useState(() => localStorage.getItem("username") || "");
  const [userId, setUserId] = useState(() => localStorage.getItem("userId") || "");
  const [userType, setUserType] = useState(() => localStorage.getItem("userType") || "");
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);

  const { selectedCompany, setSelectedCompany } = useCompany();

  const profileRef = useRef(null);
  const companyRef = useRef(null);

  const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;

  useEffect(() => {
    const type = localStorage.getItem("userType");

    if (type === "9") {
      setSelectedCompany(null);
      return;
    }

    if (type === "1") {
      const id = localStorage.getItem("companyId");
      const name = localStorage.getItem("companyName");
      const savedString = localStorage.getItem("selectedCompany");
      if (savedString) {
        try {
          const saved = JSON.parse(savedString);
          setSelectedCompany(saved);
        } catch {}
      } else if (id && name) {
        setSelectedCompany({ id, name, CompanyColourCode: "#000000" });
      } else {
        setSelectedCompany(null);
      }
      return;
    }

    if (type === "0") {
      const savedString = localStorage.getItem("selectedCompany");
      if (savedString) {
        try {
          const saved = JSON.parse(savedString);
          setSelectedCompany(saved);
        } catch {}
      }
      fetchCompanies();
    }
  }, []);

  const syncSelectedCompanyWithList = (list) => {
    if (!Array.isArray(list) || list.length === 0) return;
    const savedComp = localStorage.getItem("selectedCompany");
    let currentId = null;
    if (savedComp) {
      try {
        currentId = JSON.parse(savedComp)?.id;
      } catch {}
    }
    if (!currentId) {
      currentId = localStorage.getItem("companyId");
    }

    const match = currentId
      ? list.find((c) => String(c.CompID) === String(currentId))
      : list[0];

    if (match) {
      setSelectedCompany({
        id: match.CompID,
        name: match.Name,
        LogoPath: match.LogoPath || null,
        CompanyColourCode: match.CompanyColourCode || "#000000",
      });
    }
  };

  const fetchCompanies = async () => {
    setLoading(true);
    try {
      const uId = localStorage.getItem("userId");
      if (!uId) return;

      // 1. Check preloaded localStorage
      const saved = localStorage.getItem("companyList");
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          if (Array.isArray(parsed) && parsed.length > 0) {
            setCompanies(parsed);
            syncSelectedCompanyWithList(parsed);
          }
        } catch {}
      }

      // 2. Try Node backend API
      const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || "http://localhost:5000/api";
      try {
        const nodeRes = await fetch(`${BASE_API_URL}/company/by-master/${uId}`);
        if (nodeRes.ok) {
          const nodeData = await nodeRes.json();
          const list = nodeData.data || nodeData.Response || [];
          if (Array.isArray(list) && list.length > 0) {
            setCompanies(list);
            localStorage.setItem("companyList", JSON.stringify(list));
            syncSelectedCompanyWithList(list);
            setLoading(false);
            return;
          }
        }
      } catch (nodeErr) {
        console.warn("Node backend company fetch failed, trying rest API:", nodeErr);
      }

      // 3. Try ASP.NET REST API if configured
      if (BASE_REST_API_URL) {
        const data = new URLSearchParams();
        data.append("SecurityKey", SECURITY_KEY);
        data.append("TableName", "company");
        data.append("WhereCondition", `MasterId=${uId}`);
        data.append("*", "*");

        const apiUrl = `${BASE_REST_API_URL.replace(/\/+$/, "")}/SelectData.aspx`;
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: data.toString(),
        });

        const text = await response.text();
        const clean = text.replace(/^\uFEFF/, "").trim();
        const match = clean.match(/\{[\s\S]*\}/);
        if (match) {
          const json = JSON.parse(match[0]);
          if (json.Response && json.Response.length > 0) {
            setCompanies(json.Response);
            localStorage.setItem("companyList", JSON.stringify(json.Response));
            syncSelectedCompanyWithList(json.Response);
            setLoading(false);
            return;
          }
        }
      }
    } catch (err) {
      console.error(err);
      if (companies.length === 0) {
        showToast.error("Failed to load companies!");
      }
    } finally {
      setLoading(false);
    }
  };


  const handleSelectCompany = (company) => {
    const selected = {
      id: company.CompID,
      name: company.Name,
      LogoPath: company.LogoPath || null,
      CompanyColourCode: company.CompanyColourCode || "#000000",
    };
    setShowCompanyList(false);
    setSelectedCompany(selected);
    showToast.success(`Company changed to ${company.Name}`);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileOpen(false);
      }
      if (companyRef.current && !companyRef.current.contains(event.target)) {
        setShowCompanyList(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    setSelectedCompany(null);
    setUsername("");
    setUserId("");
    setUserType("");
    performLogout("Logged out successfully");
  };

  const filteredCompanies = companies.filter((c) =>
    companySearch ? c.Name.toLowerCase().includes(companySearch.toLowerCase()) : true
  );

  return (
    <header className="app_header_bar">
      {/* Left: Back Button & Title */}
      <div className="app_header_left">
        {!isDashboard && (
          <button
            type="button"
            className="header_back_btn"
            onClick={() => {
              if (window.history.length > 2) {
                navigate(-1);
              } else {
                navigate("/home");
              }
            }}
            title="Go back to previous page"
          >
            <i className="fa-solid fa-arrow-left header_back_icon"></i>
            <span className="header_back_text">Back</span>
          </button>
        )}
      </div>

      {/* Center: Company Selector */}
      <div className="app_header_center">
        {userType !== "9" && (
          userType === "1" ? (
            selectedCompany ? (
              <div className="active_company_pill">
                <i
                  className="fa-solid fa-building"
                  style={{ color: selectedCompany?.CompanyColourCode || undefined }}
                ></i>
                <span style={{ color: selectedCompany?.CompanyColourCode || undefined, fontWeight: "600" }}>
                  {selectedCompany.name}
                </span>
              </div>
            ) : null
          ) : (
            <div className="company_selector_wrapper" ref={companyRef}>
              <button
                type="button"
                className="company_selector_btn"
                onClick={() => {
                  if (companies.length === 0) fetchCompanies();
                  setShowCompanyList(!showCompanyList);
                }}
              >
                <i
                  className="fa-solid fa-building-circle-check company_icon"
                  style={{ color: selectedCompany?.CompanyColourCode || undefined }}
                ></i>
                <span
                  className="company_name_text"
                  style={{ color: selectedCompany?.CompanyColourCode || undefined, fontWeight: "600" }}
                >
                  {selectedCompany?.name || "Select Company"}
                </span>
                <i
                  className={`fa-solid fa-chevron-down caret_icon ${showCompanyList ? "rotate_180" : ""}`}
                  style={{ color: selectedCompany?.CompanyColourCode || undefined }}
                ></i>
              </button>

              {showCompanyList && (
                <div className="company_dropdown_menu">
                  <div className="company_dropdown_header">
                    <h6>Select Company</h6>
                    <span className="company_count_badge">{companies.length}</span>
                  </div>

                  {companies.length > 5 && (
                    <div className="company_search_box">
                      <i className="fa-solid fa-magnifying-glass"></i>
                      <input
                        type="search"
                        placeholder="Search company..."
                        value={companySearch}
                        onChange={(e) => setCompanySearch(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                  )}

                  <ul className="company_dropdown_list custom_scrollbar">
                    {filteredCompanies.map((comp) => {
                      const isSelected = selectedCompany?.id?.toString() === comp.CompID?.toString();
                      return (
                        <li
                          key={comp.CompID}
                          onClick={() => handleSelectCompany(comp)}
                          className={`company_dropdown_item ${isSelected ? "selected" : ""}`}
                        >
                          <div className="company_item_info">
                            <span
                              className="company_item_name"
                              style={{ color: comp.CompanyColourCode || undefined, fontWeight: "600" }}
                            >
                              {comp.Name}
                            </span>
                            {comp.GSTNO && (
                              <span className="company_item_gst">GST: {comp.GSTNO}</span>
                            )}
                          </div>
                          {isSelected && <i className="fa-solid fa-check check_icon"></i>}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
          )
        )}
      </div>

      {/* Right: User Profile */}
      <div className="app_header_right">
        {/* User Profile */}
        <div className="header_profile_wrapper" ref={profileRef}>
          <button
            type="button"
            className="profile_trigger_btn"
            onClick={() => setProfileOpen(!profileOpen)}
          >
            <div className="profile_avatar_box">
              <img
                src="./media/profile_image.jpg"
                alt="Avatar"
                className="profile_avatar_img"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://ui-avatars.com/api/?name=" + encodeURIComponent(username || "User") + "&background=0d9488&color=fff";
                }}
              />
            </div>
            <div className="profile_info_text">
              <span className="profile_user_name">{username || "User"}</span>
            </div>
            <i className={`fa-solid fa-chevron-down caret_icon ${profileOpen ? "rotate_180" : ""}`}></i>
          </button>

          {profileOpen && (
            <div className="profile_dropdown_menu">
              <div className="profile_dropdown_header">
                <p className="user_signed_in">Signed in as</p>
                <p className="user_full_name">{username || "User"}</p>
              </div>

              <Link
                to="/profile"
                className="profile_dropdown_item"
                onClick={() => setProfileOpen(false)}
              >
                <i className="fa-regular fa-user"></i>
                <span>My Profile</span>
              </Link>

              <div className="profile_dropdown_divider"></div>

              <button
                type="button"
                className="profile_dropdown_item logout_item"
                onClick={handleLogout}
              >
                <i className="fa-solid fa-arrow-right-from-bracket"></i>
                <span>Log Out</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

/* ==========================================================================
   DEFAULT NAVBAR WRAPPER (COMBINED)
   ========================================================================== */
function Navbar({ admin: propAdmin, setadmin: propSetAdmin }) {
  const [localAdmin, setLocalAdmin] = useState(false);
  const admin = propAdmin !== undefined ? propAdmin : localAdmin;
  const setadmin = propSetAdmin || setLocalAdmin;

  return (
    <>
      <Sidebar admin={admin} setadmin={setadmin} />
      <Header admin={admin} setadmin={setadmin} />
    </>
  );
}

export default Navbar;
